<!-- Built on the OneVedAI UI library (onevedai-input / onevedai-textarea); styling comes from the central theme. -->
@if (control) {
  <div class="form-input-container" [class.view-mode]="allowViewMode && currentMode === 'view'">
    @if (allowViewMode) {
      <div class="mode-toggle">
        @if (currentMode === 'view') {
          <button type="button" class="mode-btn" (click)="switchToEditMode()" title="Edit" aria-label="Edit">
            <span class="material-symbols-outlined">edit</span>
          </button>
        } @else {
          <button type="button" class="mode-btn" (click)="switchToViewMode()" title="View" aria-label="View">
            <span class="material-symbols-outlined">visibility</span>
          </button>
        }
      </div>
    }

    @if (currentMode === 'view') {
      <div class="view-mode-container">
        @if (label) {
          <div class="view-mode-label ds-label">{{ label }}</div>
        }
        <div class="view-mode-value" [class.empty]="!control.value">{{ getDisplayValue() }}</div>
      </div>
    } @else {
      @if (isTextarea) {
        <onevedai-textarea
          [label]="label"
          [placeholder]="placeholder"
          [value]="stringValue"
          [rows]="rows"
          [disabled]="isDisabled"
          [invalid]="isInvalid"
          [errorMessage]="displayError"
          [hint]="hint"
          (valueChange)="onValueChange($event)"
          (focusin)="onFocus()"
          (focusout)="onBlur()"
        ></onevedai-textarea>
      } @else {
        <onevedai-input
          [label]="label"
          [type]="inputType"
          [placeholder]="placeholder"
          [value]="stringValue"
          [min]="min === undefined ? '' : '' + min"
          [max]="max === undefined ? '' : '' + max"
          [required]="required"
          [disabled]="isDisabled"
          [invalid]="isInvalid"
          [errorMessage]="displayError"
          (valueChange)="onValueChange($event)"
          (focusin)="onFocus()"
          (focusout)="onBlur()"
        ></onevedai-input>
        @if (hint && !isInvalid) {
          <div class="form-input-hint">{{ hint }}</div>
        }
      }
    }
  </div>
}
